//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 29/01/2025
// Version       : 1
// Description   : Agregar Frecuencias en KM para tareas de vehículos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Box,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Typography,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AgregarFrecuenciaKilometros(props) {
  const [datosFrecuenciaKilometros, setDatosFrecuenciaKilometros] = useState({
    valor_km: "",
    estado: null,
  });

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  // DESHABILITAR BOTON AL GUARDAR
  const [disBtn, setDisBtn] = useState(false);

  //Funcion para guardar al crear
  const guardarCrear = async (e) => {
    console.log("Estoy por guardar");
    setDisBtn(true);
    e.preventDefault();
    await fetch(UrlApi + "/frecuencia_kilometros", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        valor_km: datosFrecuenciaKilometros.valor_km,
        estado: 1,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La frecuencia se guardó exitosamente!");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar la frecuencia");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  //  ------------------------------------------------------------------------

  const almacenar = (e) => {
    setDatosFrecuenciaKilometros({
      ...datosFrecuenciaKilometros,
      [e.target.name]: e.target.value,
    });
  };

  //  ------------------------------------------------------------------------

  // Cierre de la notificación
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setDisBtn(false);

    props.onFrecuenciaGuardada(); // Función para obtener valores de nuevo en el componente padre
    props.handleCloseAgregarFrecuencia(); // Cerrar este componente
  };

  return (
    <>
      <Box
        sx={{
          border: "2px solid #2B76A6",
          borderRadius: 1,
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            mt: 0,
            mb: 2,
            display: "flex",
            justifyContent: "flex-start", // alineado a la izquierda
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{
              backgroundColor: "#2B76A6",
              borderBottomRightRadius: "12px", // solo esquina inferior derecha
              padding: "8px 18px",
            }}
          >
            Agregar Frecuencia
          </Typography>
        </DialogTitle>

        <DialogContent>
          <form onSubmit={guardarCrear}>
            <Grid container mt={1} mb={3}>
              <Grid xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Frecuencia"
                  placeholder="Kilometros"
                  required
                  focused
                  autoComplete="off"
                  onChange={almacenar}
                  name="valor_km"
                  value={datosFrecuenciaKilometros.valor_km}
                  onInput={(e) => {
                    // Filtrar solo números enteros positivos
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">km</InputAdornment>
                      ),
                    },
                  }}
                />
              </Grid>
            </Grid>

            <Grid container direction={{ xs: "column", sm: "row" }}>
              <Grid xs={9}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={props.handleCloseAgregarFrecuencia}
                  disabled={disBtn}
                >
                  Volver
                </Button>
              </Grid>
              <Grid xs={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={disBtn}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Box>

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AgregarFrecuenciaKilometros;
